import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 
  
  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getAttendance = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.attendance.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate) {

    const response = await axios(configws)
    data = { attendance: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.attendance.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(attendance => {
      return (
        (
          attendance.meeting_date.toLowerCase().includes(queryLowered) ||
          attendance.meeting_end_date.toLowerCase().includes(queryLowered) ||
          attendance.reason_for_meeting.toLowerCase().includes(queryLowered) ||
          attendance.meeting_type.toLowerCase().includes(queryLowered)
        )
      )
  })
  return [
    200,
    {
      allData: data.attendance,
      total: filteredData.length,
      attendance: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

//----------------------------------------
// GET: Return list if attendance
//----------------------------------------

let dataAttendance = JSON.parse(localStorage.getItem("dataAttendance")) || { attendance: [], startDate: '', endDate: ''}

mock.onGet('apps/attendance').reply(async config => {
  
  const user = getUserData()

  if (config.reset) {
    dataAttendance = { attendance: [], startDate: '', endDate: ''}
  }

  const body = {
    date_from : config.startDate,
    date_to   : config.endDate,
    office_id : user.usercoc.office_id

  }
  const result = await getAttendance(dataAttendance, 1, GetApiCOC('getlistMeeting'), user.token, body, config)
  dataAttendance = { attendance: result[1].allData, startDate: config.startDate, endDate: config.endDate }

  localStorage.setItem("dataAttendance", JSON.stringify(dataAttendance))

  return result
})

//----------------------------------------
// POST: Add attendance 
//----------------------------------------

mock.onPost(/\/api\/attendance\/\d+/).reply(async config => {
  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertMeeting'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})